import { defaultTheme } from "react-admin";

const theme = {
  ...defaultTheme,
  palette: {
    ...defaultTheme.palette,
    primary: {
      main: "#7A005E",
      dark: "#5c0247ff",
      light: "#EDE7F1",
    },
    secondary: {
      main: "#7A005E",
    },
    info: {
      main: "#00000081",
    },
    error: {
      main: "#7A005E",
      primary: "#D41153",
    },
    success: {
      main: "#007A7A",
      light: "#04b0b0ff",
    },
    warning: {
      main: "#ff9800",
      light: "#fbf6dc",
    },
    white: {
      main: "#ffffff",
    },
    tableStripe: {
      main: "#F4EDF2",
    },
    homeIcon: {
      main: "transparent",
    },
  },
  components: {
    ...defaultTheme.components,
    MuiFilledInput: {
      // Name of the component ⚛️ / style sheet
      defaultProps: {
        backgroundcolor: "#F6F9FE",
      },
    },
    RaAppBar: {
      styleOverrides: {
        root:
          process.env.REACT_APP_TEST_ENVIRONMENT === "true"
            ? { color: "#fff", backgroundColor: "#7A005E" }
            : { color: "#fff" },
      },
    },
    // RaConfigurable: {
    //   styleOverrides: {
    //     root: { color: "#fff" },
    //   },
    // },
    // RaLoadingIndicator: {
    //   styleOverrides: {
    //     root: { color: "#fff" },
    //   },
    // },
    RaSimpleFormIterator: {
      styleOverrides: {
        root: {
          "& .RaSimpleFormIterator-line": {
            borderLeft: "5px solid #7A005E",
            backgroundColor: "#F5F5F5",
            borderRadius: "5px",
            padding: "2rem",
            marginBottom: "2.5rem",
          },
          "&  .RaSimpleFormIterator-form ": {
            width: "100%",
            position: "relative",
          },
        },
      },
    },
    RaArrayInput: {
      styleOverrides: {
        root: {
          "& .RaArrayInput-label": {
            color: "#7A005E",
            fontWeight: 700,
            marginBottom: "7px",
            whiteSpace: "pre-wrap",
          },
        },
      },
    },
    RaLabeled: {
      styleOverrides: {
        root: {
          "& .RaLabeled-label": {
            color: "#7A005E",
            fontWeight: 600,
            fontSize: 11,
          },
        },
      },
    },
    MuiTypography: {
      defaultProps: {
        sx: { fontSize: 14 },
      },
    },
    RaSidebar: {
      styleOverrides: {
        root: {
          "& .RaSidebar-fixed": {
            position: "fixed",
            height: "92vh",
            overflowY: "auto",
          },
        },
      },
    },
    RaMultiLevelMenu: {
      styleOverrides: {
        root: {
          backgroundColor: "#F6F9FE",
        },
      },
    },
    RaMenuItem: {
      styleOverrides: {
        root: {
          color: "#000",
          whiteSpace: "pre-wrap",
          "& .RaMenuItem-link": {
            whiteSpace: "pre-wrap",
          },
          "& .RaMenuItem-nestedList": {
            paddingLeft: "0px",
          },
          "& .RaMenuItem-itemButton.active": {
            whiteSpace: "pre-wrap",
            paddingLeft: "0.325rem",
            backgroundColor: "#fff",
            borderBottom: "1px solid #7A005E",
          },
          "& .RaMenuItem-active": {
            color: "#000",
          },
          "& .RaMenuItem-menuIcon": {
            color: "#707070",
          },
        },
      },
    },
    MuiTable: {},
    MuiTableHead: {
      defaultProps: {
        sx: {
          backgroundColor: "black",
          color: "white",
        },
      },
    },
    RaDatagrid: {
      styleOverrides: {
        root: {
          backgroundColor: "#fff",
          border: "0.5px solid #d6d1d0a3",
          borderRadius: "5px",
          "& .RaDatagrid-headerCell": {
            backgroundColor: "#7A005E",
            color: "#fff",
            fontWeight: 700,
            fontSize: 15,
            paddingRight: "5px",
            paddingLeft: "10px",
            textAlign: "center",
          },
          "& .MuiTableSortLabel-root.Mui-active": {
            color: "#fff",
          },
          "& .MuiTableSortLabel-root.Mui-active .MuiTableSortLabel-icon": {
            color: "#fff",
          },
        },
      },
    },
  },
  homeIconStyle: {
    color: "#fff",
  },
  logoutStyle: {
    flexDirection: "column",
    justifyContent: "center",
    "& .MuiSvgIcon-root": { color: "#FFFFFF", fontSize: "125%" },
    position: "relative",
  },
  RaCreateButton: {
    styleOverrides: {
      root: {
        backgroundColor: "#7A005E",
        color: "#fff",
        padding: ".3rem 1rem",
        "&:hover": {
          backgroundColor: "#5c0247ff",
        },
      },
    },
  },
  RaSaveButton: {
    styleOverrides: {
      root: {
        backgroundColor: "#7A005E",
        color: "#fff",
        padding: ".3rem 1rem",
        "&:hover": {
          backgroundColor: "#5c0247ff",
        },
      },
    },
  },
  RaEditButton: {
    styleOverrides: {
      root: {
        backgroundColor: "#7A005E",
        color: "#fff",
        padding: ".3rem 1rem",
        "&:hover": {
          backgroundColor: "#5c0247ff",
        },
      },
    },
  },
  RaButton: {
    styleOverrides: {
      root: {
        backgroundColor: "#7A005E",
        color: "#fff",
        padding: ".3rem 1rem",
        "&:hover": {
          backgroundColor: "#5c0247ff",
        },
      },
    },
  },
  RaBulkDeleteWithUndoButton: {
    styleOverrides: {
      root: {
        color: "#FFF",
        "&:hover": {
          backgroundColor: "#fff",
          color: "#7A005E",
        },
      },
    },
  },
};

export default theme;
